import React, { useState, useMemo } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import '../../styles/AdminPage.css';

const API = process.env.REACT_APP_BACKEND_URL;

const ResetPasswordPage = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = useMemo(() => params.get('token') || '', [params]);
  const [pw, setPw] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (pw.length < 12) {
      setError('New password must be at least 12 characters.');
      return;
    }
    if (pw !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    setBusy(true);
    try {
      const res = await axios.post(`${API}/api/admin/reset-password`, {
        token,
        new_password: pw,
      });
      setSuccess(res.data.message || 'Password reset.');
      setTimeout(() => navigate('/admin'), 2200);
    } catch (err) {
      setError(err.response?.data?.detail || 'Reset link is invalid or expired.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="admin-page admin-login-page">
      <div className="admin-login-card">
        <h1 className="admin-login-title">Set new password</h1>
        <p className="admin-login-subtitle">
          Choose a strong password (minimum 12 characters). Use a passphrase or a password manager.
        </p>

        {!token ? (
          <p className="admin-login-error" data-testid="admin-reset-no-token">
            Missing reset token in the URL. Please use the link from your email.
          </p>
        ) : success ? (
          <p className="admin-forgot-done" data-testid="admin-reset-success">
            ✅ {success}
            <br />
            Redirecting to login…
          </p>
        ) : (
          <form onSubmit={submit} className="admin-login-form">
            <label className="admin-field">
              <span className="admin-field-label">New password</span>
              <input
                type="password"
                value={pw}
                onChange={(e) => setPw(e.target.value)}
                required
                minLength={12}
                autoComplete="new-password"
                className="admin-input"
                data-testid="admin-reset-pw"
              />
            </label>
            <label className="admin-field">
              <span className="admin-field-label">Confirm new password</span>
              <input
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
                minLength={12}
                autoComplete="new-password"
                className="admin-input"
                data-testid="admin-reset-confirm"
              />
            </label>
            {error && (
              <p className="admin-login-error" data-testid="admin-reset-error">
                {error}
              </p>
            )}
            <button
              type="submit"
              className="admin-login-btn"
              disabled={busy}
              data-testid="admin-reset-submit"
            >
              {busy ? <Loader2 className="admin-spinner-inline" size={16} /> : 'Reset password'}
            </button>
          </form>
        )}

        <p className="admin-login-forgot">
          <Link to="/admin">← Back to login</Link>
        </p>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
